import { Component, OnInit } from '@angular/core';
import { RoutineService } from 'src/app/services/routine.service';
import { StateService } from 'src/app/services/state.service';
import { TutorialsService } from 'src/app/services/tutorials.service';
import { Modal } from 'bootstrap';

import videojs from 'video.js';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss'],
})
export class VideoModalComponent implements OnInit {
  player: any;
  tutorialId?: number;

  constructor(
    private tutorialsService: TutorialsService,
    private stateService: StateService
  ) {}

  ngOnInit(): void {
    const modal = document.getElementById('videoModal');

    modal!.addEventListener('show.bs.modal', () => {
      const container = document.getElementsByClassName('modal-body');
      const videoElement = document.createElement('video');
      videoElement.id = 'vid1';
      videoElement.classList.add('video-js');

      container[0].appendChild(videoElement);

      this.tutorialId = this.stateService.selectedTabletTutorialId;

      const playerOpts = {
        aspectRatio: '9:16',
        controls: true,
        autoplay: true,
        muted: true,
        loop: true,
        controlBar: {
          children: [
            'playToggle', // Play/pause button
            'volumePanel', // Volume control
            'currentTimeDisplay', // Current time of the video
            'timeDivider', // Separator between current time and duration
            'durationDisplay', // Duration of the video
            'progressControl', // Seek bar
          ],
        },
      };

      this.player = videojs('vid1', playerOpts); //

      this.tutorialsService.getVideo(this.tutorialId!).subscribe({
        next: (videoBlob: Blob) => {
          const videoUrl = URL.createObjectURL(videoBlob);
          const newUrl = { src: videoUrl, type: 'video/mp4' };

          this.player.src(newUrl);
          this.player.play();
        },
      });
    });

    modal!.addEventListener('hide.bs.modal', () => {
      this.player.dispose();
      this.player = null;
    });
  }
}
